import net, { IRequestOptions, IRequestOptionsWithPass } from '@/services/net'
import { PackEntityCorpRealNameAuthInfoVO } from '../Type/PackEntityCorpRealNameAuthInfoVO'

interface DataModel {
	cid?: string
}

/**
 *	查询客户实名认证信息
 * @param {DataModel} [data] 封装对象
 * @param {string} [data.cid] 企业id
 */

export function realNameauthInfo(
	data: DataModel,
	options: IRequestOptionsWithPass,
): Promise<PackEntityCorpRealNameAuthInfoVO>
export function realNameauthInfo(
	data: DataModel,
	options?: IRequestOptions,
): Promise<
	PackEntityCorpRealNameAuthInfoVO extends { msg: unknown } ? PackEntityCorpRealNameAuthInfoVO['msg'] : undefined
>
export function realNameauthInfo(data: DataModel, options: IRequestOptionsWithPass | IRequestOptions = {}) {
	const { cid } = data
	return net('/frontApi/cust/realName/authInfo', {
		method: 'post',
		params: {
			cid,
		},

		...(options || {}),
	})
}
